import axios from 'axios';
import { mapToCamelCase } from './utils';

export enum Methods {
  get = 'get',
  post = 'post',
  put = 'put',
  delete = 'delete',
  patch = 'patch'
}

export const fetcher = (
  {
    method,
    url,
    authToken,
    authTokenRequired = false,
    data,
    errorCallback
  }: {
    method: Methods,
    url: string,
    authToken?: string | null,
    authTokenRequired?: boolean,
    data?: any,
    errorCallback?: any
  }
) => {
  if (!(method in Methods)) {
    throw new Error("Method not supported");
  }
  if (!url) {
    throw new Error("URL not provided");
  }
  if (authTokenRequired && !authToken) {
    throw new Error ("Auth token required");
  }
  if ((method === Methods.post || method === Methods.put || method === Methods.patch) && !data) {
    throw new Error("Data not provided");
  }
  return axios({
    method,
    url,
    ...(data && { data }),
    ...(authToken && {
      headers: {
        "DTOKEN": `${authToken}`
      }
    }),
  }).then(res => {
    return mapToCamelCase(res.data);
  }).catch(err => {
    if (errorCallback) {
      errorCallback();
    }
    // handle error after refresh
    return Promise.reject(err);
  })
}
